import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ fullScreen }) => {
  let className = "loader";
  if (fullScreen) { className += " fullScreen"; }
  return (
    <div className={className}>
      <div className="wrapper">
        <div className="inner" />
        <div className="text">LOADING</div>
      </div>
    </div>
  );
}

Loader.propTypes = {
  fullScreen: PropTypes.bool,
};

export default Loader;
